import { Link, useLocation } from "@tanstack/react-router";
import { usesApprovedDesign } from "./VisualSystem";
import { hostKind } from "@/lib/hostKind";
import {
  buildMetadata,
  formatBuildVersionLabel,
} from "@/features/navigation/buildMetadata";

export function AppVersionFooter() {
  const { pathname } = useLocation();
  if (usesApprovedDesign(pathname, hostKind()) && pathname !== "/")
    return (
      <footer className="approved-app-footer" aria-label="Build version">
        <span>
          © {new Date().getFullYear()} Tktic{" "}
          <span className="ml-3 text-xs">
            {formatBuildVersionLabel(buildMetadata)}
          </span>
        </span>
        <nav aria-label="Legal">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </nav>
      </footer>
    );
  return (
    <footer
      aria-label="Build version"
      className="pointer-events-none fixed bottom-2 right-2 z-30 max-w-[calc(100vw-1rem)] print:hidden"
    >
      <span className="block truncate rounded border border-rule bg-elevated px-2 py-1 font-mono text-[0.625rem] leading-none text-ink-muted">
        {formatBuildVersionLabel(buildMetadata)}
      </span>
    </footer>
  );
}
